(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurakar-header"] && !Shopify.designMode) return;
  try {
    
// The custom header uses the full cart page, so complete successful cart actions there.
import('@shopify/events').then(({StandardEvents})=>{
  document.addEventListener(StandardEvents.cartLinesUpdate,event=>{
    event.promise?.then(({cart,detail})=>{
      if(detail?.didError)return;
      const link=document.querySelector('.ak-header__cart');
      if(!link)return;
      const count=cart?.totalQuantity;
      if(typeof count==='number'){
        link.querySelector('b').textContent=String(count);
        link.setAttribute('aria-label',link.querySelector('span').textContent.trim()+' '+count);
      }
      if(event.action==='add')window.location.assign(link.href);
      else if(window.location.pathname===new URL(link.href).pathname)window.location.reload();
    }).catch(()=>{});
  });
});
document.addEventListener('toggle',function(e){if(e.target.matches?.('.ak-mobile-nav'))e.target.querySelector('summary').setAttribute('aria-expanded',String(e.target.open))},true);
document.addEventListener('click',function(e){document.querySelectorAll('.ak-mobile-nav[open]').forEach(item=>{if(!item.contains(e.target)||e.target.closest('a'))item.removeAttribute('open')})});
document.addEventListener('keydown',function(e){if(e.key==='Escape')document.querySelectorAll('.ak-mobile-nav[open]').forEach(item=>{item.removeAttribute('open');item.querySelector('summary').focus()})});
window.addEventListener('resize',function(){if(window.matchMedia('(min-width:1101px)').matches)document.querySelectorAll('.ak-mobile-nav[open]').forEach(item=>item.removeAttribute('open'))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurakar-information"] && !Shopify.designMode) return;
  try {
    
  function openAuraKarPolicy(hash) {
    const policyIds = ['shipping-delivery', 'returns-refunds', 'privacy-policy', 'terms'];
    const targetId = hash.replace(/^#/, '');
    if (!policyIds.includes(targetId)) return;
    const target = document.getElementById(targetId);
    if (target && target.matches('details.ak-information__detail')) target.open = true;
  }

  openAuraKarPolicy(window.location.hash);
  window.addEventListener('hashchange', () => openAuraKarPolicy(window.location.hash));
  document.addEventListener('shopify:section:load', () => openAuraKarPolicy(window.location.hash));
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    if (link.origin === window.location.origin && link.pathname === window.location.pathname) {
      openAuraKarPolicy(link.hash);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurakar-showcase"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ak-showcase')){
  customElements.define('ak-showcase',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;
      this.initialized=true;
      this.slides=[...this.querySelectorAll('[data-slide]')];
      this.choices=[...this.querySelectorAll('[data-choice]')];
      if(this.slides.length<2)return;
      this.index=0;
      this.abort=new AbortController();
      const opts={signal:this.abort.signal};
      this.reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused=this.dataset.autoplay!=='true'||this.reduced.matches;
      this.visible=true;
      this.hovered=false;
      this.focused=false;
      this.querySelector('[data-controls]').hidden=false;
      this.classList.add('is-ready');
      this.show(0);
      this.querySelector('[data-previous]').addEventListener('click',()=>this.move(-1),opts);
      this.querySelector('[data-next]').addEventListener('click',()=>this.move(1),opts);
      this.querySelector('[data-pause]').addEventListener('click',()=>{this.paused=!this.paused;this.sync()},opts);
      this.choices.forEach((a,i)=>a.addEventListener('click',e=>{if(e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;e.preventDefault();this.paused=true;this.show(i);this.sync()},opts));
      this.addEventListener('mouseenter',()=>{this.hovered=true;this.sync()},opts);
      this.addEventListener('mouseleave',()=>{this.hovered=false;this.sync()},opts);
      this.addEventListener('focusin',()=>{this.focused=true;this.sync()},opts);
      this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.sync()})},opts);
      document.addEventListener('visibilitychange',()=>this.sync(),opts);
      this.reduced.addEventListener('change',()=>{if(this.reduced.matches)this.paused=true;this.sync()},opts);
      document.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0){this.paused=true;this.show(i);this.sync()}},opts);
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync()},{threshold:.15});
      this.observer.observe(this);
      this.sync();
    }
    show(i){
      this.index=(i+this.slides.length)%this.slides.length;
      this.slides.forEach((s,n)=>{s.hidden=n!==this.index;s.inert=n!==this.index});
      this.choices.forEach((a,n)=>{if(n===this.index)a.setAttribute('aria-current','true');else a.removeAttribute('aria-current')});
      this.querySelector('[data-position]').textContent=String(this.index+1).padStart(2,'0')+' / '+String(this.slides.length).padStart(2,'0');
    }
    move(step){this.paused=true;this.show(this.index+step);this.sync()}
    sync(){
      clearInterval(this.timer);
      const b=this.querySelector('[data-pause]');
      b.setAttribute('aria-pressed',String(this.paused));
      b.setAttribute('aria-label',this.paused?b.dataset.playLabel:b.dataset.pauseLabel);
      b.textContent=this.paused?b.dataset.playShort:b.dataset.pauseShort;
      if(!this.paused&&!this.hovered&&!this.focused&&this.visible&&!document.hidden)this.timer=setInterval(()=>this.show(this.index+1),Number(this.dataset.interval)||6000);
    }
    disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();this.observer?.disconnect();this.initialized=false}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
